import { render, staticRenderFns } from "./UpdateInstructor.vue?vue&type=template&id=3e7381c1"
import script from "./UpdateInstructor.vue?vue&type=script&lang=ts"
export * from "./UpdateInstructor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports